import React from "react";
import { ArrowRight, Snowflake } from "lucide-react";
import { company, heroImage } from "../mock";
import Reveal from "./Reveal";

export default function Hero() {
  return (
    <section id="home" className="hero-bg pt-28 pb-16 md:pt-36 md:pb-24 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full opacity-30 blur-3xl" style={{ background: "radial-gradient(circle,#00b4d8,transparent 70%)" }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-10 items-center relative">
        <div>
          <Reveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white shadow-sm text-[color:var(--brand-blue)] text-xs font-semibold mb-5">
              <Snowflake size={14} /> Member of a global cooling network
            </div>
          </Reveal>
          <Reveal delay={80}>
            <p className="overline text-sm md:text-base mb-2">Leading the</p>
            <h1 className="section-title text-4xl sm:text-5xl lg:text-6xl mb-5">
              Bhawani Kitchen <span style={{ color: "var(--brand-blue)" }}>Solutions</span> Under One Roof
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed max-w-xl mb-8">
              At {company.name}, we stand as one of the region&rsquo;s leading commercial
              refrigeration equipment manufacturers, driven by innovation and a vision to be
              the world&rsquo;s foremost solution provider. We offer a wide range of commercial
              refrigeration solutions to global giants.
            </p>
          </Reveal>
          <Reveal delay={240}>
            <div className="flex flex-wrap gap-4">
              <a href="#products" className="brand-btn inline-flex items-center gap-2 px-6 py-3.5 rounded-md font-semibold">
                Explore Products <ArrowRight size={18} />
              </a>
              <a href="#about" className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md font-semibold border border-slate-300 text-slate-700 hover:border-[color:var(--brand-blue)] hover:text-[color:var(--brand-blue)] transition-colors">
                Read More
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <div className="relative">
            <div className="absolute inset-0 rounded-3xl rotate-3 bg-white shadow-xl" />
            <img
              src={heroImage}
              alt="Commercial refrigeration equipment"
              className="relative rounded-3xl object-cover w-full h-[360px] md:h-[480px] shadow-2xl"
            />
            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl flex items-center justify-center" style={{ background: "var(--brand-ice)" }}>
                <Snowflake className="text-[color:var(--brand-blue)]" size={22} />
              </div>
              <div>
                <div className="font-head font-bold text-lg" style={{ color: "var(--brand-navy)" }}>45+</div>
                <div className="text-xs text-slate-500">Nations served</div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
